import { cn } from '@/utils/cn'
import type { TxPanelSharedProps } from '../txPanel/txPanel'
import { TxPanelContent } from '../txPanel/txPanelContent'
import { PositionDetails } from './positionDetails'
import { ProjectedEarnings } from './projectedEarnings'

interface SidePanelProps {
  className?: string
}

export const SidePanel = ({
  vault,
  walletAddress,
  transactionsContext,
  tabValue,
  setTabValue,
  tabsConfig,
  positionValue,
  parsedAmount,
  totalPositionValue,
  isContainRewards,
  isContextError,
  isContextFetching,
  onRetryContext,
  className,
}: TxPanelSharedProps & SidePanelProps) => {
  return (
    <aside className={cn('h-fit flex-col gap-4', className)} data-role="side-panel" data-location="side">
      <TxPanelContent
        vault={vault}
        transactionsContext={transactionsContext}
        tabValue={tabValue}
        setTabValue={setTabValue}
        tabsConfig={tabsConfig}
        isContextError={isContextError}
        isContextFetching={isContextFetching}
        onRetryContext={onRetryContext}
      />

      <ProjectedEarnings
        vault={vault}
        parsedAmount={parsedAmount}
        positionValue={positionValue}
        tabValue={tabValue}
        isContainRewards={isContainRewards}
      />

      <PositionDetails totalPositionValue={totalPositionValue} vault={vault} walletAddress={walletAddress} />
    </aside>
  )
}
